"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynatraceTimeMetricStatus = exports.DynatraceReporterLogLevel = void 0;
var DynatraceReporterLogLevel;
(function (DynatraceReporterLogLevel) {
    DynatraceReporterLogLevel["INFO"] = "info";
    DynatraceReporterLogLevel["WARN"] = "warn";
    DynatraceReporterLogLevel["ERROR"] = "error";
})(DynatraceReporterLogLevel || (exports.DynatraceReporterLogLevel = DynatraceReporterLogLevel = {}));
var DynatraceTimeMetricStatus;
(function (DynatraceTimeMetricStatus) {
    DynatraceTimeMetricStatus[DynatraceTimeMetricStatus["STARTING"] = 0] = "STARTING";
    DynatraceTimeMetricStatus[DynatraceTimeMetricStatus["STARTED"] = 1] = "STARTED";
    DynatraceTimeMetricStatus[DynatraceTimeMetricStatus["STOPPED"] = 2] = "STOPPED";
    DynatraceTimeMetricStatus[DynatraceTimeMetricStatus["CANCELLED"] = 3] = "CANCELLED";
    DynatraceTimeMetricStatus[DynatraceTimeMetricStatus["FINISHING"] = 4] = "FINISHING";
    DynatraceTimeMetricStatus[DynatraceTimeMetricStatus["FINISHED"] = 5] = "FINISHED";
    DynatraceTimeMetricStatus[DynatraceTimeMetricStatus["REPORTED"] = 6] = "REPORTED";
})(DynatraceTimeMetricStatus || (exports.DynatraceTimeMetricStatus = DynatraceTimeMetricStatus = {}));
//# sourceMappingURL=types.js.map